"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BET_RENEWAL_SUMMARY_TAB = exports.BET_CUSTOMER_SUMMARY_TAB = void 0;
var BET_CUSTOMER_SUMMARY_TAB = 'customerSummary';
exports.BET_CUSTOMER_SUMMARY_TAB = BET_CUSTOMER_SUMMARY_TAB;
var BET_RENEWAL_SUMMARY_TAB = 'renewalSummary';
exports.BET_RENEWAL_SUMMARY_TAB = BET_RENEWAL_SUMMARY_TAB;